<template>
  <div class="row animated fadeIn">
    <div class="col-md-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">{{task}}</h4>
          <div class="row">
            <div class="col-md-12">
              <ul class="nav nav-tabs" id="myTab" role="tablist">
                <li class="nav-item">
                  <a
                      class="nav-link active show"
                      id="team-announcements-tab"
                      data-toggle="tab"
                      href="#team-announcements"
                      role="tab"
                      aria-controls="up"
                  >Active</a
                  >
                </li>
                <li class="nav-item">
                  <a
                      class="nav-link"
                      id="announcement-tab"
                      data-toggle="tab"
                      href="#announcements"
                      role="tab"
                      aria-controls="up"
                  >Resolved</a
                  >
                </li>

              </ul>
            </div>
          </div>
        </div>
        <div class="card-body" style="padding-top: 0 !important">
          <div class="tab-content customer-table">
            <div id="team-announcements" class="tab-pane active show">
             <ManualTaskTable :parentType="type" tab="active"/>
            </div>

            <div id="announcements" class="tab-pane fade">
              <ManualTaskTable :parentType="type" tab="resolved"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ManualTaskTable from "@/components/Admin/Sales/ManualTaskTable.vue";

export default {
  name: "ManualTask",
  components: {ManualTaskTable},
  props: {
    task: {
      required: true,
      type: String
    },
    type: {
      type: String
    }
  },
  data() {
    return {
      message: '',
      title: '',
      loading: '',
      key: ''
    }
  },
  methods: {
  }
}
</script>
<style scoped lang="scss">
.nav-tabs .nav-item .nav-link.active:before,
.nav-tabs .nav-item .nav-link.active:hover:before,
.nav-tabs .nav-item .nav-link.active:focus:before {
  border: 0;
}

.nav-tabs {
  border-bottom: 1px solid #dee2e6;
}

.nav-tabs .nav-link {
  border: 1px solid transparent !important;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}

.nav-tabs .nav-item.show .nav-link,
.nav-tabs .nav-link.active {
  color: #495057;
  background-color: #fff;
  border-color: #dee2e6 #dee2e6 #fff !important;
}

.nav-tabs .nav-item .nav-link.active {
  color: #5b7cfb;
}
.notes-section {
  background-color: #ef8057;
  color: white;
  border-radius: 3px;
  padding: 0.5rem;
  margin-bottom: 0.5rem;
  hr {
    border-top: 1px solid rgba(255,255,255,.5);
  }
}
table{
  tr {
    .task-width {
      width:70%;
    }
    td {
      /deep/  p {
        margin: 0 !important;
      }
    }
  }
}
hr {
  &.h-3 {
    border-top: 3px solid rgba(0,0,0,.1);
  }
}
.pagination{
  display: inline-flex !important;
}
.cf-status-icons {
  i {
    font-size: 25px;
    margin: 0 !important;
    &.disabled {
      color: #7E7E7E;
    }

    &.enabled {
      color: #47f260;
    }

    &.yellow {
      color: #f2b61d;
    }
    &.default {
      color: currentColor;
    }
    &:hover{
      background-color:transparent !important;
      color: currentColor !important;
    }
  }
}
.cpy-btn{
  margin: 0;
}
.fs-10{
  font-size: 10px;
}
.h-43{
  height:43px;
}
.domain-card{
  background: #f0f0f4;
  box-shadow: none;
  border-radius: 8px !important;
  &:hover{
    box-shadow: 0 6px 10px 3px rgba(0, 0, 0, 0.15);;
  }
  .collapse-btn{
    margin-top: 0.5rem !important;
  }
  .domain-head{
    display: flex;
    justify-content: space-between;
    .h5-m0 {
      margin: 0;
    }
    .ul-m0{
      margin: 0;
    }
  }
  .domain-info{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .badge{
      text-transform: none !important;
    }
  }
}
.bl-bt{
  display: flex;
  align-items: flex-end;
  button {
    margin: 0 !important;
  }
}
.cursor-pointer{
  cursor: pointer;
}
pre{
  display: inline-block;
  margin-bottom: 0px;
}
</style>
